const HTML_ENTITY: Record<string, string> = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: '"'
};

/** SRT 안에 섞인 HTML/ASS 표시 명령은 버리고 실제 자막 글자만 남긴다. */
export function subtitlePlainText(value: string) {
  return value
    .replace(/<[^>]*>/g, "")
    .replace(/\{\\[^}]*}/g, "")
    .replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, code: string) => {
      if (code[0] !== "#") return HTML_ENTITY[code.toLowerCase()] ?? entity;
      const hex = code[1]?.toLowerCase() === "x";
      const point = Number.parseInt(code.slice(hex ? 2 : 1), hex ? 16 : 10);
      try { return Number.isSafeInteger(point) ? String.fromCodePoint(point) : entity; }
      catch { return entity; }
    })
    .replace(/[ \t]+/g, " ")
    .trim();
}
